module.exports = __webpack_public_path__ + "assets/img/Affiches_018.f61c9c3c.jpg";